import {
	useEffect, useState,
} from 'react';
import dayjs from 'dayjs';
import { DATE_PARSE_FORMAT, useUrlParams } from '@aleph/shared-components';
import { useSupergridMutations, useSuperGridValidate } from '@aleph/supergrid';
import RedditViewSuperGrid from 'wb-reddit/app/routes/superGrid/view/grid';
import RedditMutatorSuperGrid from 'wb-reddit/app/routes/superGrid/mutator/container';
import { RedditLevel, RedditSuperGridContext } from 'wb-reddit/app/routes/superGrid/utils';
import AdminOverlay from 'wb-reddit/app/routes/superGrid/tool/adminOverlay';
import AdAccountMutator from 'wb-reddit/app/routes/superGrid/mutator/adAccount/adAccountMutator';
import useRedditClientMutator from 'wb-reddit/app/routes/superGrid/mutator/adAccount/hooks/useRedditAdClientMutator';
import { GridApi } from 'ag-grid-community';
import { useNavigate, useParams } from 'react-router-dom';

const defaultRedditSuperGridUrlParams = {
	level:   RedditLevel.AD_ACCOUNT,
	filters: {},
	date:    `${dayjs().subtract(6, 'days').format(DATE_PARSE_FORMAT)}:${dayjs().format(DATE_PARSE_FORMAT)}`,
	sort:    [{
		colId: 'impressions',
		sort:  'desc',
	}],
};

const RedditSuperGrid = () => {
	const [gridApi, setGridApi] = useState<GridApi | null | undefined>(null);
	const navigate = useNavigate();

	const { params, setUrlParam, setUrlParams } = useUrlParams({
		defaultParams: defaultRedditSuperGridUrlParams,
		navigate,
		useParams,
	});
	const { context: { setValidations } } = useSuperGridValidate();

	const { hasMutations, clearMutations } = useSupergridMutations();

	const mutationsPresent = hasMutations();

	const {
		mutatingClient,
		setMutatingClient,
	} = useRedditClientMutator();

	useEffect(() => {
		if (!mutationsPresent) {
			setUrlParams({
				...params,
				inCreate:      undefined,
				creationLevel: undefined,
			});
			setValidations([]);
		} else {
			setUrlParam('inCreate', true);
		}
	}, [mutationsPresent]);

	useEffect(() => {
		if (!params.inCreate && mutationsPresent) {
			clearMutations();
		}
	}, [params.inCreate]);

	if (!params.date) {
		return null;
	}

	return (
		<RedditSuperGridContext.Provider
			value={{ gridApi, setGridApi }}
		>
			<div
				className="flex flex-1 min-w-0"
			>
				{ mutatingClient
					&& <AdAccountMutator
						onClose={() => setMutatingClient(undefined)}
						title={mutatingClient?.adAccount?.adAccountName ?? ''}
					/>
				}
				<AdminOverlay />
				{hasMutations() ? <RedditMutatorSuperGrid /> : <RedditViewSuperGrid />}
			</div>
		</RedditSuperGridContext.Provider>
	);
};

export default RedditSuperGrid;
